import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import * as uuid from 'uuid'

@Component({
  selector: 'app-filter-string-option-select',
  templateUrl: './filter-string-option-select.component.html',
  styleUrls: ['./filter-string-option-select.component.scss']
})
export class FilterStringOptionSelectComponent {

  ContainerId = uuid.v4()

  @Input() IconUrl: string = "/assets/icons/credit-card.svg"
  @Input() PlaceholderFilter: string = "Matricula"
  @Input() NoOptionsText: string = "Ninguna matricula introducida"
  @Input() SelectedText: string = "Matriculas"
  @Input() SelectedOptions: string[] | any[] = []
  @Input() Options: string[] = []
  @Input() Multiselect: boolean = false;
  @Input() PopupWidth: string | undefined;

  @Output() filterValueEmitter = new EventEmitter<string[]>()

  FilterOpen: boolean = false;

  ngOnInit() {
  }

  openFilter() {
    this.FilterOpen = !this.FilterOpen;
  }

  deleteFilter(event: Event) {
    event.stopPropagation();
    this.SelectedOptions = []
    this.FilterOpen = false;
    this.emitFilterValue();
  }


  emitFilterValue() {
    this.filterValueEmitter.emit(this.SelectedOptions);
  }


  updateSelectedOption(option: string) {
    if (this.Multiselect) {
      if (this.SelectedOptions.includes(option)) {
        this.SelectedOptions = this.SelectedOptions.filter((x: string) => { return x !== option })
      } else {
        this.SelectedOptions.push(option);
      }
    } else {
      this.SelectedOptions = [option]
    }
    this.emitFilterValue();
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;
    const absoluteElement = document.getElementById(this.ContainerId);

    if (
      this.FilterOpen &&
      absoluteElement &&
      !absoluteElement.contains(targetElement)
    ) {
      this.FilterOpen = false;
    }
  }


}

